import React from 'react';
import ClubExpenseForm from './ClubExpenseForm';

const EditClubExpensePage = () => <ClubExpenseForm formType="edit" />;

export default EditClubExpensePage;
